import { ZoneType } from '../../../api/static/zones';
import ConfiguratorLayerEditorStageZoneText from './ConfiguratorLayerEditorStageZoneText';
import ConfiguratorLayerEditorStageZoneImage from './ConfiguratorLayerEditorStageZoneImage';

/**
 * @enum
 * @readonly
 */
const ComponentMap = Object.freeze({
  [ZoneType.TEXT]: ConfiguratorLayerEditorStageZoneText,
  [ZoneType.IMAGE]: ConfiguratorLayerEditorStageZoneImage,
});

export default {
  name: 'ConfiguratorLayerEditorStageZoneFactory',
  functional: true,
  props: {
    type: {
      type: String,
      required: true,
      validator(v) {
        return Object.values(ZoneType).includes(v);
      },
    },
  },
  render(h, context) {
    return h(
      ComponentMap[context.props.type],
      { ...context.data, props: context.props },
      context.children
    );
  },
};
